document.addEventListener("DOMContentLoaded", function () {
    const splideElements = document.querySelectorAll(
      '[class^="shop-by-recipe--blogs-splide"]'
    );
    const tabSvgWrappers = document.querySelectorAll(
      ".regional-tab--svg-wrapper"
    );
  
    splideElements.forEach((element) => {
      new Splide(element, { 
        type: "slide",
        perPage: 3,
        perMove: 1,
        breakpoints: {
          1024: {
            perPage: 3,
            gap: 16,
          },
          768: {
            perPage: 2,
            gap: 8,
          },
        },
        gap: 24,
        pagination: true,
        arrows: false,
      }).mount();
    });
  
    const tabs = document.querySelectorAll(".regional-tab--item");
    const contents = document.querySelectorAll(".custom-container");
  
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const id = tab.getAttribute("data-id");
  
        contents.forEach((content) => (content.style.display = "none"));
        tabSvgWrappers.forEach((wrapper) => wrapper.classList.remove("active"));
  
        const activeContent = document.querySelector(
          `.custom-container[data-index="${id}"]`
        );
        if (activeContent) {
          activeContent.style.display = "block";
        }
  
        const activePolygon = document.querySelector(
          `.regional-tab--svg-wrapper.tab-id-${id}`
        );
        if (activePolygon) {
          activePolygon.classList.add("active");
        }
      });
    });
  
    if (tabs.length > 0 && contents.length > 0) {
      tabs[0].classList.add("active");
      contents[0].style.display = "block";
  
      const firstPolygon = document.querySelector(
        ".regional-tab--svg-wrapper.tab-id-1"
      );
      if (firstPolygon) {
        firstPolygon.classList.add("active");
      }
    }
  });
  